import { ActivityIndicator } from '@capsicum/common-web';
import styled, { useTheme } from 'styled-components';

export const LoadingIndicator = () => {
	const { colors } = useTheme();

	return (
		<S.Loading>
			<ActivityIndicator color={colors.icons.main.enabled} />
		</S.Loading>
	);
};
namespace S {
	export const Loading = styled.div`
		margin-top: ${({ theme }) => theme.spacings.xlarge};
		display: flex;
		align-self: center;
		justify-content: center;
		width: 100%;
	`;
}
